import { useCallback } from "react";
import { useAuth } from "../auth/useAuth";

// Single place where an API call gets its bearer token: the session token
// Flask issued at sign-in (see auth/AuthProvider.jsx).
export const useApi = () => {
  const { token, signOut } = useAuth();

  const apiFetch = useCallback(
    async (path, options = {}) => {
      const response = await fetch(path, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...options.headers,
          Authorization: `Bearer ${token}`,
        },
      });
      // Expired, or the account was deleted or suspended: back to sign-in.
      if (response.status === 401) signOut();
      return response;
    },
    [token, signOut]
  );

  return { apiFetch };
};
